import React from "react"
import { Accordion, Button, Col, Row } from "react-bootstrap"
import { QrCodeDetails, QRCodeProps } from "../../models/Workflow"
import QRCode from "react-qr-code"
import { Stack } from "react-bootstrap"
import { useTranslation } from 'react-i18next'
import { printQR } from "../../utils/printQR.utils"

const translatn = 'workflowQRCode.'
const parentClass = 'vcr-pp-workflow-qr-code'

export const WorkflowQRCodes = ({ qrCodeDetails }: { qrCodeDetails: QrCodeDetails }) => {
    const { t } = useTranslation()
    return <Accordion defaultActiveKey="0" >

        {qrCodeDetails.samples.map((sample: QRCodeProps, index: number) => (
            <div className={`${parentClass}`} key={index}>
                <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header>
                        <span className={`${parentClass}-accordion-left-text`}>
                            Sample ID: {sample.sampleId}
                        </span>
                        <span className={`${parentClass}-accordion-right-text`} >
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <Stack gap={3}>
                            <div>
                                <Row>
                                    <Col lg={3}>
                                        <h5 className={'mb-4'}>{t(`${translatn}clinicalSampleBarcode`)}</h5>
                                        <div className={`${parentClass}-qrInfo`}>
                                            <QRCode
                                                className={`${parentClass}-qrcode`}
                                                value={qrCodeDetails.deidentifiedData}
                                                viewBox={`0 0 25 25`}
                                            />
                                            <div className={`${parentClass}-qrcode-label`}>{sample.label}</div>
                                        </div>
                                    </Col>
                                </Row>
                                <div>
                                    <Row>
                                        {sample.blockLable?.length > 0 && (<h5>{t(`${translatn}biorepositorySamplesBarcode`)}</h5>)
                                        }
                                        {sample.blockLable?.map((info, index) => (
                                            <Col lg={3} key={index} className={`${parentClass}-qrInfo`}>
                                                <QRCode
                                                    className={`${parentClass}-qrcode`}
                                                    value={qrCodeDetails.deidentifiedData}
                                                    viewBox={`0 0 25 25`}
                                                />
                                                <div className={`${parentClass}-qrcode-label`}>{info}</div>
                                            </Col>
                                        ))
                                        }
                                    </Row>
                                </div>
                            </div>
                            <Row>
                                <Col>
                                    <Button className={`${parentClass}-save-create-barcode mx-0`} onClick={() => printQR(qrCodeDetails.deidentifiedData, sample.blockLable, sample.label)}>
                                        {t(`${translatn}printBarcode`)}
                                    </Button>
                                </Col>
                            </Row>
                        </Stack>                        
                    </Accordion.Body>
                </Accordion.Item>
            </div>
        ))}
    </Accordion>
} 